import { Stack } from '@mui/material';
import Typography from '@/components/Typography';
import { walletsT } from '@/components/Crypto/types';
import Badge from '@/components/Badge';
import useResponsive from '@/hooks/useResponsive';
import { useRouter } from 'next/router';
import getLocalFile from '@/utils/getLocalFile';

const WalletsComponents = () => {
  const { matches } = useResponsive();
  const {
    query: { symbol }
  } = useRouter();
  const marketName = symbol?.toString().toUpperCase() || '';
  const data = getLocalFile(marketName, 'info');
  const content = getLocalFile(marketName, 'content');

  return (
    <Stack direction="column" gap={4} mt={2}>
      <Stack direction="row" flexWrap="wrap" gap={2}>
        {data?.cryptoInglance?.wallets?.map((item: walletsT, index: number) => (
          <Badge
            imageSize={20}
            content={item.title_fa}
            image={item.image}
            key={index}
            link={item.link}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default WalletsComponents;
